import { useContext, useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";

import TalentPoolsListingHeader from "./TalentPoolsListingHeader";
import TalentPoolsTable from "./TalentPoolsTable";
import BaseLoader from "../../components/ui/BaseLoader";
import { LayoutContext } from "../../context/LayoutContext";
import { fetchTalentPool } from "../../services/api/talentPool";

const TalentPools = () => {
  const { isBannerVisible } = useContext(LayoutContext);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState(search);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 20,
  });

  const [rowCount, setRowCount] = useState(0);
  const {
    isLoading: isFetchTalentPoolApiLoading,
    data: talentPoolData,
    refetch: refetchTalentPool,
  } = useQuery({
    queryKey: [
      "talentPool",
      debouncedSearch,
      paginationModel.page,
      paginationModel.pageSize,
    ],
    queryFn: () =>
      fetchTalentPool({
        search: debouncedSearch,
        page: paginationModel.page + 1,
        limit: paginationModel.pageSize,
      }),
    keepPreviousData: true,
  });
  useEffect(() => {
    if (talentPoolData?.data?.totalCount !== undefined) {
      setRowCount(talentPoolData.data.totalCount);
    }
  }, [talentPoolData]);

  return (
    <>
      <BaseLoader isLoading={isFetchTalentPoolApiLoading} />
      <div
        className={`bg-[#F6F6F6] sm:fixed sticky 2xl:w-[95.2%] xl:w-[93.2%] lg:w-[90.6%] md:w-[87.5%] sm:w-[95%] w-full h-screen transition-all pt-4 ${
          isBannerVisible ? "top-[104px] sm:mt-0 mt-12" : "top-[42px]"
        }`}
      >
        <TalentPoolsListingHeader
          refetchTalentPool={refetchTalentPool}
          search={search}
          setSearch={setSearch}
          setDebouncedSearch={setDebouncedSearch}
        />
        <TalentPoolsTable
          talentPoolData={talentPoolData?.data}
          isFetchTalentPoolApiLoading={isFetchTalentPoolApiLoading}
          refetchTalentPool={refetchTalentPool}
          paginationModel={paginationModel}
          setPaginationModel={setPaginationModel}
          rowCount={rowCount}
        />
      </div>
    </>
  );
};

export default TalentPools;
